module.exports = __webpack_public_path__ + "img/logo.105b244b.png";